import React, { useState, useEffect, useRef } from "react";
import {
  Box,
  Grid,
  Typography,
  Button,
  TextField,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  CircularProgress,
  Table, 
  TableBody, 
  TableRow, 
  TableCell,
  InputAdornment,
  Snackbar
} from "@material-ui/core";
import AttachFileIcon from "@material-ui/icons/AttachFile";
import { Alert } from '@material-ui/lab';
import { API, graphqlOperation, Storage, Auth } from "aws-amplify";
import { useParams, useHistory } from "react-router-dom";
import { getRecaptchaToken } from '../../../utils/recaptcha';

// 現在のユーザーの認証情報を取得する関数
const getCurrentAuthToken = async () => {
  try {
    const session = await Auth.currentSession();
    return session.getIdToken().getJwtToken();
  } catch (error) {
    console.error("認証情報の取得に失敗:", error);
    return null;
  }
};

// URLからS3のキーを抽出する関数
const extractS3KeyFromUrl = (url) => {
  if (!url) return null;
  
  // 既にキーの形式（http://から始まらない）ならそのまま返す
  if (!url.startsWith('http')) return url;
  
  try {
    // URLからimage-product/以降のパスを抽出
    const match = url.match(/\/image-product\/[^?]+/);
    if (match) {
      return decodeURIComponent(match[0].substring(1)); // 先頭の / を削除
    }
    return null;
  } catch (error) {
    console.error("URLからキーの抽出に失敗:", error);
    return null;
  }
};

const EditProduct = () => {
  const { UUID } = useParams();
  const history = useHistory();
  const [overlay, setOverlay] = useState(false);
  const [originalImgURL, setOriginalImgURL] = useState(null); // 初期画像URL保存用
  const [productForm, setProductForm] = useState({
    UUID: "",
    stripeID: "",
    title: "",
    URL: [],
    description: "",
    rawPrice: 300,
    feeRate: 0.036,
    platformFee: 200,
    mailtext: "",
    note: "",
    imgFile: null,
    imgURL: null,
    imgType: null,
    questions: [],
    identityId: "",
  });
  const [dialogs, setDialogs] = useState({
    editDialog: false,
    stopDialog: false,
    restartDialog: false,
    deleteDialog: false,
    stopFlagDialog: false,
    stopConfirmDialog: false
  });
  const [stopBtn, setStopBtn] = useState(false);
  const [disableStopBtn, setDisableStopBtn] = useState(false);
  const [stopMessage, setStopMessage] = useState("");
  const [token, setToken] = useState(null);
  const [alertMessage, setAlertMessage] = useState('');

  const fetchProduct = async (productId) => {
    setOverlay(true);
    try {
      const getProductQuery = `
          query GetProduct($id: ID!) {
            getProduct(id: $id) {
              id
              title
              description
              price
              note
              imgURL
              URL
              mailtext
              form
              stopFlag
              disableFlag
              stripeID
              sellerID
              identityId
            }
          }
        `;
      // const response = await API.graphql(graphqlOperation(getProduct, { id: productId }));
      const response = await API.graphql(
        graphqlOperation(getProductQuery, { id: UUID }),
        { authMode: 'AMAZON_COGNITO_USER_POOLS' }
      );
      const product = response.data?.getProduct;
      if (!product) {
        setOverlay(false);
        return;
      }

      if (product.stopFlag !== undefined) {
        setStopBtn(product.stopFlag);
      }
  
      let imageUrl = null;
      if (product.imgURL !== null && product.imgURL !== "" && product.imgURL !== "null") {
        const trimmed = product.imgURL.trim();
        try {
          const s3Key = extractS3KeyFromUrl(trimmed);
          
          if (s3Key) {
            try {
              const url = await Storage.get(s3Key, {
                level: "public",
                expires: 86400, // 24時間の有効期限
                validateObjectExistence: true
              });
              imageUrl = url;
            } catch (storageErr) {
              console.error("4. Storage.get失敗:", {
                エラー: storageErr,
                メッセージ: storageErr.message,
                S3キー: s3Key
              });
            }
          } else {
            imageUrl = trimmed; // S3キーが抽出できない場合は元のURLを使用
          }
        } catch (err) {
          console.error("5. 画像URL処理エラー:", err);
          imageUrl = null;
        }
      } else {
      }
      setOriginalImgURL(imageUrl);
      
      let productUrls = [];
      if (typeof product.URL === "string") {
        try {
          productUrls = JSON.parse(product.URL);
        } catch (error) {
          productUrls = product.URL.slice(1, -1).split(",").map(url => url.trim().replace(/['"]+/g, ""));
        }
      } else if (Array.isArray(product.URL)) {
        productUrls = product.URL;
      }
  
      const hasUrls = productUrls.some(url => url.trim() !== "");
      
      setProductForm({
        UUID: product.id || "",
        stripeID: product.stripeID || "",
        title: product.title || "",
        description: product.description || "",
        rawPrice: product.price !== undefined ? product.price : "",
        platformFee: product.platformFee !== undefined ? product.platformFee : 200, 
        feeRate: product.feeRate !== undefined ? product.feeRate : 0.036, 
        mailtext: product.mailtext || "",
        note: product.note || "",
        imgURL: imageUrl,
        questions: product.form ? JSON.parse(product.form) : [],
        identityId: product.identityId || "",
        URL: productUrls.length > 0 ? productUrls : [""],
        quantity: product.quantity !== undefined ? Number(product.quantity) : null,
        stopFlag: product.stopFlag || false,
      });
  
    } catch (error) {
      console.error("商品情報の取得に失敗しました:", error);
    } finally {
      setOverlay(false);
    }
  };  
  
  useEffect(() => {
    if (UUID) {
      fetchProduct(UUID);
    }
  }, [UUID]);  

  useEffect(() => {
    if (productForm.stopFlag !== undefined) {
      setStopBtn(productForm.stopFlag);
    }
  }, [productForm.stopFlag]);
  
  useEffect(() => {
  }, [productForm]);
  

  useEffect(() => {
    if (productForm.imgURL && !productForm.imgURL.startsWith("http")) {
      const fetchImageUrl = async () => {
        try {
          const signedUrl = await Storage.get(productForm.imgURL, { expires: 3600 });
          setProductForm((prev) => ({ ...prev, imgURL: signedUrl }));
        } catch (error) {
        }
      };
  
      fetchImageUrl();
    }
  }, [productForm.imgURL]);  
  
  useEffect(() => {
  }, [productForm.imgURL]);

  const fileInputRef = useRef(null);

  const handleImageUpload = async (event) => {
    const file = event.target.files[0];
    if (!file) return;
  
    const imgExt = file.type.split("/")[1] || "jpeg";
    const key = `image-product/${productForm.UUID}.${imgExt}`;
  
    try {
      // publicに直接保存
      await Storage.put(key, file, {
        level: "public",
        contentType: file.type,
      });
  
     // public URLを組み立てて保存
    const publicUrl = `https://amplify-pittaputreact1-newdev-5a5ac-deployment.s3.ap-northeast-1.amazonaws.com/public/${key}`;

    setProductForm((prev) => ({
      ...prev,
      imgFile: file,
      imgURL: publicUrl,
      imgType: file.type,
    }));
  } catch (error) {
    console.error("画像アップロード失敗:", error);
    setAlertMessage("画像のアップロードに失敗しました");
  }
};
  
  const handleDialogClose = (dialogName) => {
    setDialogs({ ...dialogs, [dialogName]: false });
  };

  const handleQuantityChange = (event) => {
    let value = event.target.value;
  
    if (!/^\d*$/.test(value)) return;
  
    if (value === "") {
      setProductForm((prev) => ({
        ...prev,
        quantity: value,
      }));
      return;
    }
    value = Number(value);
    if (productForm.URL.some(url => url.trim() !== "")) {
      value = 1;
    }
  
    if (value >= 1 && value <= 1000) {
      setProductForm((prev) => ({
        ...prev,
        quantity: value,
      }));
    }
  };

  // 販売停止・再開機能
  const handleStopProduct = async (flag) => {
    setOverlay(true);
    const sentence = flag ? "停止" : "再開";
    setAlertMessage(`販売${sentence}処理が完了しました`);
    let errMessage = `販売${sentence}処理に失敗しました`;

    // 認証トークンの取得
    const authToken = await getCurrentAuthToken();
    if (!authToken) {
      setAlertMessage('認証エラーが発生しました。再ログインしてください。');
      setOverlay(false);
      return;
    }

    const updateProduct = `
      mutation UpdateProduct{
        updateProduct(input: {
          id: "${productForm.UUID}",
          stopFlag: ${flag}
        }) {
          id
          stopFlag
        }
      }
    `;

    try {
      // 認証トークンをヘッダーに含める
      const response = await API.graphql({
        query: updateProduct,
        authMode: 'AMAZON_COGNITO_USER_POOLS',
        headers: { Authorization: authToken }
      });
      
      setStopBtn(flag);
      setDialogs(prev => ({
        ...prev,
        stopDialog: false,
        restartDialog: false
      }));
      setAlertMessage(`販売${sentence}処理が完了しました`);
    } catch (error) {
      console.error(error);
      setAlertMessage(errMessage);
    } finally {
      setOverlay(false);
    }
  };

  // 商品削除機能
  const handleDeleteProduct = async () => {
    setOverlay(true);
  
    try {
      // S3画像を削除
      const s3Key = extractS3KeyFromUrl(productForm.imgURL);
      if (s3Key) {
        await Storage.remove(s3Key, { level: 'public' });
      }
  
      // DynamoDBの商品データを完全削除（deleteProductミューテーションを使用）
      const authToken = await getCurrentAuthToken();
      if (!authToken) {
        setAlertMessage('認証エラーが発生しました。再ログインしてください。');
        setOverlay(false);
        return;
      }
  
      const mutation = `
        mutation DeleteProduct {
          deleteProduct(input: {
            id: "${productForm.UUID}"
          }) {
            id
          }
        }
      `;
  
      await API.graphql({
        query: mutation,
        authMode: 'AMAZON_COGNITO_USER_POOLS',
        headers: { Authorization: authToken },
      });
  
      setAlertMessage('商品を完全に削除しました');
      setTimeout(() => {
        history.push('/dashboard');
      }, 1500);
    } catch (error) {
      console.error("削除失敗:", error);
      setAlertMessage('商品の削除に失敗しました');
    } finally {
      setOverlay(false);
    }
  };
  
  const REQUIRED_MESSAGE = "必須事項です";
  const [errors, setErrors] = useState({});
  
  const validateForm = () => {
    let newErrors = {};
    
    if (!productForm.title.trim()) newErrors.title = REQUIRED_MESSAGE;
    if (!productForm.mailtext.trim()) newErrors.mailtext = REQUIRED_MESSAGE;
  
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };  

  const handleUpdateProduct = async () => {
    if (!validateForm()) {
      return;
    }

    setOverlay(true);
    
    // 画像処理
    // 画像が変更されたかをチェック（新しい画像がアップロードされたか、originalImgURLと現在のURLが異なるか）
    const imageHasChanged = (productForm.imgURL !== originalImgURL && originalImgURL !== null);
    if (imageHasChanged) {
      // 既存の画像がある場合は削除
      if (originalImgURL != null && originalImgURL != undefined && originalImgURL != "null") {
        try {
          // 既存の画像を削除
          const s3Key = extractS3KeyFromUrl(originalImgURL);
          if (s3Key) {
            await Storage.remove(s3Key, { level: 'public' });
          } else {
            console.warn("有効なS3キーを取得できませんでした");
          }
        } catch (error) {
          console.error("商品画像の削除に失敗しました:", error);
          setAlertMessage('商品画像の削除に失敗しました');
          setOverlay(false);
          return;
        }
      }
      
      // 新しい画像をアップロード
      if (productForm.imgFile !== null) {
        try {
          const imgExtension = productForm.imgType.replace('image/', '');
          const key = 'image-product/' + productForm.UUID + '.' + imgExtension;
          
          const result = await Storage.put(key, productForm.imgFile, {
            level: 'protected',
            contentType: productForm.imgType
          });
          
          setProductForm(prev => ({ ...prev, imgURL: result.key }));
        } catch (error) {
          console.error("商品画像のアップロードに失敗しました:", error);
          setAlertMessage("商品画像のアップロードに失敗しました");
          setOverlay(false);
          return;
        }
      }
    }

    // 商品情報更新
    const formJson = JSON.stringify(productForm.questions);
    const URLs = JSON.stringify(productForm.URL);
    const indentionRegEX = /\n/gi;
    
    const updateProductMutation = `
      mutation UpdateProduct{
        updateProduct(input: {
          id: "${productForm.UUID}",
          title: "${productForm.title}",
          URL: "${URLs.replace(/"/g, '\\"')}",
          description: "${(productForm.description || "").replace(indentionRegEX, '\\n')}",
          price: ${productForm.rawPrice},
          mailtext: "${(productForm.mailtext || "").replace(indentionRegEX, '\\n')}",
          note: "${(productForm.note || "").replace(indentionRegEX, '\\n')}",
          form: "${formJson.replace(/"/g, '\\"')}",
          imgURL: "${productForm.imgURL || null}"
        }) {
          id
          title
          sellerID
          stripeID
          URL
          description
          price
          mailtext
          note
          form
          imgURL
        }
      }
    `;

    try {
      // 認証トークンを取得
      const authToken = await getCurrentAuthToken();
      if (!authToken) {
        setAlertMessage('認証エラーが発生しました。再ログインしてください。');
        setOverlay(false);
        return;
      }
      
      // 認証トークンをヘッダーに含めてGraphQL実行
      const response = await API.graphql({
        query: updateProductMutation,
        authMode: 'AMAZON_COGNITO_USER_POOLS',
        headers: { Authorization: authToken }
      });
      
      setAlertMessage('商品情報を更新しました');
      setOverlay(false);
      setDialogs(prev => ({ ...prev, editDialog: true }));
      
      // 2秒後にダッシュボードへリダイレクト
      setTimeout(() => {
        history.push('/dashboard');
      }, 2000);
    } catch (error) {
      console.error("商品の更新に失敗しました:", error);
      setAlertMessage('商品の更新に失敗しました');
    } finally {
      setOverlay(false);
    }
  };

  const [showLabel, setShowLabel] = useState({
    description: !!productForm.description,
    mailtext: !!productForm.mailtext,
    note: !!productForm.note,
  });

  useEffect(() => {
    setShowLabel({
      description: !!productForm.description,
      mailtext: !!productForm.mailtext,
      note: !!productForm.note,
    });
  }, [productForm]);
  
  const handleFocus = (field) => {
    setShowLabel((prev) => ({ ...prev, [field]: true }));
  };
  
  const handleBlur = (field, value) => {
    setShowLabel((prev) => ({ ...prev, [field]: !!value }));
  };

  const handleInputChange = (field, value) => {
    setProductForm((prev) => ({
      ...prev,
      [field]: value,
    }));
  };
  
  const [urls, setUrls] = useState([]);

  useEffect(() => {
    const initRecaptcha = async () => {
      const token = await getRecaptchaToken('edit_product');
      setToken(token);
    };

    initRecaptcha();
    const interval = setInterval(initRecaptcha, 2 * 60 * 1000);

    return () => clearInterval(interval);
  }, []);
  
  return (
    <Box maxWidth={600} mx="auto" mt={4}>
      {overlay && (
        <Box
          position="fixed"
          top={0}
          left={0}
          width="100%"
          height="100%"
          bgcolor="rgba(0,0,0,0.5)"
          display="flex"
          justifyContent="center"
          alignItems="center"
        >
          <CircularProgress />
        </Box>
      )}

    <Typography variant="h4" align="center" gutterBottom>
      商品の編集
    </Typography>

          <TextField
            fullWidth
            label="商品名"
            value={productForm.title}
            onChange={(e) => handleInputChange("title", e.target.value)}
            margin="normal"
            inputProps={{ maxLength: 100 }}
            error={!!errors.title}
            helperText={errors.title}
          />

    <Box my={2} textAlign="center" onClick={() => fileInputRef.current?.click()} style={{ cursor: "pointer" }}>
      {productForm.imgURL && typeof productForm.imgURL === 'string' && !['null', 'undefined'].includes(productForm.imgURL) ? (
        <img
          src={productForm.imgURL}
          alt={productForm.title || '商品画像'} 
          style={{
            maxWidth: "100%",
            width: "300px",
            height: "auto",
            borderRadius: "4px",
          }}
        />
      ) : null}
    </Box>

    <Box
      display="flex"
      alignItems="center"
      my={2}
      onClick={() => fileInputRef.current?.click()}
      style={{ 
        cursor: "pointer", 
        borderBottom: "2px solid #ccc", 
        paddingBottom: "4px" 
      }}
    >
      <AttachFileIcon color="action" style={{ marginRight: 8 }} />
      <Typography variant="body2" color="textSecondary">商品の紹介画像</Typography>
    </Box>

    <input
      ref={fileInputRef}
      type="file"
      accept="image/*"
      style={{ display: "none" }}
      onChange={handleImageUpload}
    />

    <Box my={4}>
      <Typography variant="body2" color="textSecondary">
        価格(300円以上、ピッタプット利用料と決済手数料を含む税込価格)
      </Typography>
      <TextField
        fullWidth
        type="number"
        value={productForm.rawPrice}
        onChange={(e) => {
          let value = e.target.value;

          if (value.length > 1 && value.startsWith("0")) {
            value = value.replace(/^0+/, "");
          }
      
          setProductForm((prev) => ({
            ...prev,
            rawPrice: value ? Number(value) : "",
          }));
        }}
        margin="normal"
        inputProps={{ min: 300 }}
        InputProps={{
          endAdornment: <InputAdornment position="end">円</InputAdornment>,
        }}
      />

      <Table style={{ width: "100%", maxWidth: 400, margin: "0 auto" }}>
        <TableBody>
          <TableRow>
            <TableCell
              style={{
                textAlign: "left",
                paddingLeft: "4px",
                paddingRight: "4px",
                whiteSpace: "nowrap",
              }}
            >
              ピッタプット利用料
            </TableCell>
            <TableCell
              style={{
                textAlign: "right",
                paddingLeft: "4px",
                paddingRight: "4px",
                whiteSpace: "nowrap",
              }}
            >
              {productForm.platformFee} 円
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell
              style={{
                textAlign: "left",
                paddingLeft: "4px",
                paddingRight: "4px",
                whiteSpace: "nowrap",
              }}
            >
              決済手数料
            </TableCell>
            <TableCell
              style={{
                textAlign: "right",
                paddingLeft: "4px",
                paddingRight: "4px",
                whiteSpace: "nowrap",
              }}
            >
              {Math.floor(productForm.rawPrice * productForm.feeRate)} 円
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell
              style={{
                textAlign: "left",
                paddingLeft: "4px",
                paddingRight: "4px",
                borderBottom: "none",
                whiteSpace: "nowrap",
              }}
            >
              利益（振込額）
            </TableCell>
            <TableCell
              style={{
                textAlign: "right",
                paddingLeft: "4px",
                paddingRight: "4px",
                borderBottom: "none",
                whiteSpace: "nowrap",
              }}
            >
              {productForm.rawPrice - productForm.platformFee - Math.floor(productForm.rawPrice * productForm.feeRate)} 円
            </TableCell>
          </TableRow>
        </TableBody>
      </Table>
    </Box>

    <Box my={5}>
      <TextField
        fullWidth
        variant="outlined"
        multiline
        value={productForm.description}
        placeholder="商品の説明"
        label="商品の説明"
        InputLabelProps={{ shrink: true }}
        onChange={(e) => setProductForm({ ...productForm, description: e.target.value })}
        onFocus={() => handleFocus("description")}
        onBlur={(e) => handleBlur("description", e.target.value)}
        style={{
          backgroundColor: '#fff',
          borderRadius: '4px'
        }}
        inputProps={{
          style: {
            height: '100px',
            overflow: 'auto'
          }
        }}
      />
    </Box>

    <Box my={4}>
      {productForm.URL.map((url, index) => (
        <Box key={index} display="flex" alignItems="center" mb={2}>
          <TextField
            fullWidth
            label="商品URL"
            value={url}
            margin="normal"
            onChange={(e) => {
              const updatedUrls = [...productForm.URL];
              updatedUrls[index] = e.target.value;
              setProductForm({ ...productForm, URL: updatedUrls });
            }}
          />
          <Box display="flex" alignItems="center" ml={2}>
            {index > 0 && (
              <Button
                variant="outlined"
                color="secondary"
                size="small"
                onClick={() => {
                  const updatedUrls = productForm.URL.filter((_, i) => i !== index);
                  setProductForm({ ...productForm, URL: updatedUrls });
                }}
              >
                削除
              </Button>
            )}
            <Button
              variant="contained"
              color="primary"
              size="small"
              style={{ marginLeft: index > 0 ? 8 : 0 }}
              onClick={() => setProductForm({ ...productForm, URL: [...productForm.URL, ""] })}
            >
              追加
            </Button>
          </Box>
        </Box>
      ))}
    </Box>
    
    <TextField
      label="購入個数"
      type="number"
      fullWidth
      value={productForm.URL.some(url => url.trim() !== "") ? "1" : productForm.quantity || ""}
      onChange={handleQuantityChange}
      disabled={productForm.URL.some(url => url.trim() !== "")}
      inputProps={{
        min: 1,
        max: productForm.URL.some(url => url.trim() !== "") ? 1 : 1000,
      }}
    />

    <Box my={5}>
      <TextField
        fullWidth
        variant="outlined"
        multiline
        value={productForm.mailtext}
        placeholder="振込完了後に送信するメール文面"
        label={showLabel.mailtext ? "振込完了後に送信するメール文面" : ""}
        InputLabelProps={{
          shrink: true,
          style: errors.mailtext ? { color: "red" } : {},
        }}
        error={!!errors.mailtext}
        helperText={errors.mailtext} 
        onChange={(e) => handleInputChange("mailtext", e.target.value)}
        onFocus={() => handleFocus("mailtext")}
        onBlur={(e) => handleBlur("mailtext", e.target.value)}
        style={{
          backgroundColor: '#fff',
          borderRadius: '4px'
        }}
        inputProps={{
          style: {
            height: '100px',
            overflow: 'auto',
            color: 'black'
          }
        }}
      />
    </Box>

    <Box my={10}>
      <TextField
        fullWidth
        variant="outlined"
        multiline
        value={productForm.note}
        placeholder="備考"
        label={showLabel.note ? "備考" : ""}
        InputLabelProps={{ shrink: true }}
        onChange={(e) => handleInputChange("note", e.target.value)}
        onFocus={() => handleFocus("note")}
        onBlur={(e) => handleBlur("note", e.target.value)}
        style={{
          backgroundColor: '#fff',
          borderRadius: '4px'
        }}
        inputProps={{
          style: {
            height: '100px',
            overflow: 'auto'
          }
        }}
      />
    </Box>

    <Grid container justifyContent="center" spacing={2}>
      <Grid item>
        <Button
          variant="contained"
          color="primary"
          onClick={handleUpdateProduct}
        >
          更新
        </Button>
      </Grid>
      {!disableStopBtn && (
        <>
          <Grid item>
          <Button
            variant="contained"
            color={stopBtn ? "primary" : "secondary"}
            onClick={() =>
              stopBtn
                ? setDialogs((prev) => ({ ...prev, restartDialog: true }))
                : setDialogs((prev) => ({ ...prev, stopConfirmDialog: true }))
            }
          >
            {stopBtn ? "販売再開" : "販売停止"}
          </Button>
          </Grid>
          <Grid item>
            <Button
              variant="contained"
              color="secondary"
              onClick={() =>
                setDialogs({ ...dialogs, deleteDialog: true })
              }
            >
              削除
            </Button>
          </Grid>
        </>
      )}
    </Grid>

      <Dialog
        open={dialogs.editDialog || false}
        onClose={() => handleDialogClose("editDialog")}
      >
        <DialogTitle>更新完了</DialogTitle>
        <DialogContent>商品の情報を更新しました。</DialogContent>
        <DialogActions>
          <Button onClick={() => handleDialogClose("editDialog")}>閉じる</Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={dialogs.stopConfirmDialog || false}
        onClose={() => setDialogs((prev) => ({ ...prev, stopConfirmDialog: false }))}
      >
        <DialogTitle>確認</DialogTitle>
        <DialogContent>
          本当にこの商品を販売停止しますか？
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => setDialogs((prev) => ({ ...prev, stopConfirmDialog: false }))}
            color="primary"
          >
            キャンセル
          </Button>
          <Button
            onClick={async () => {
              setDialogs((prev) => ({ ...prev, stopConfirmDialog: false }));
              await handleStopProduct(true);
              setStopBtn(true);
            }}
            color="secondary"
          >
            停止
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={dialogs.restartDialog || false}
        onClose={() => setDialogs((prev) => ({ ...prev, restartDialog: false }))}
      >
        <DialogTitle>確認</DialogTitle>
        <DialogContent>
          本当にこの商品を販売再開しますか？
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => setDialogs((prev) => ({ ...prev, restartDialog: false }))}
            color="primary"
          >
            キャンセル
          </Button>
          <Button
            onClick={async () => {
              setDialogs((prev) => ({ ...prev, restartDialog: false }));
              await handleStopProduct(false);
              setStopBtn(false);
            }}
            color="secondary"
          >
            再開
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={dialogs.deleteDialog || false}
        onClose={() => setDialogs({ ...dialogs, deleteDialog: false })}
      >
        <DialogTitle>確認</DialogTitle>
        <DialogContent>
          本当にこの商品を削除しますか？
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setDialogs({ ...dialogs, deleteDialog: false })} color="primary">
            キャンセル
          </Button>
          <Button onClick={handleDeleteProduct} color="secondary">
            削除
          </Button>
        </DialogActions>
      </Dialog>

      <Snackbar 
        open={!!alertMessage} 
        autoHideDuration={6000} 
        onClose={() => setAlertMessage('')}
      >
        <Alert 
          onClose={() => setAlertMessage('')} 
          severity={
            alertMessage === '商品情報を更新しました' || 
            alertMessage === '商品を削除しました' ||
            alertMessage === '販売再開処理が完了しました' ||
            alertMessage === '販売停止処理が完了しました'
            ? 'success' : 'error'}
        >
          {alertMessage}
        </Alert>
      </Snackbar>
    </Box>
  );
};

export default EditProduct;